import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import type { ReactNode } from "react";
import Styles from "./Table.module.scss";

type Props = DeepReadonly<{
	children: ReactNode;
}>;

export function Table({ children }: Props) {
	return <table className={Styles.Table}>{children}</table>;
}
